import { useTranslation } from 'react-i18next';

import PropTypes from 'prop-types';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { generateDiffStrings } from 'utils/func/diffString';
import DiffColumn from '../DiffColumn';

export default function SoftProductCompareTable({ products1, products2, diffObj }) {
  // #region Data
  const { t } = useTranslation();
  // #endregion

  // #region Render
  const formatIndex = (_, { rowIndex }) => rowIndex + 1;

  const formatName = (rowIndex, side = 'left') =>
    generateDiffStrings(products1?.[rowIndex]?.name, products2?.[rowIndex]?.name)?.[side];

  const formatEvaluativeCriteria = (rowIndex, side = 'left') =>
    generateDiffStrings(
      products1?.[rowIndex]?.evaluativeCriteria,
      products2?.[rowIndex]?.evaluativeCriteria
    )?.[side];

  const formatNote = (rowIndex, side = 'left') =>
    generateDiffStrings(products1?.[rowIndex]?.note, products2?.[rowIndex]?.note)?.[side];
  // #endregion Render

  return (
    <tr>
      <td>
        <div className="my-2">
          <DataTable
            value={products1}
            showGridlines
            dataKey="id"
            responsiveLayout="scroll"
            scrollable
          >
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.order'
              )}
              body={formatIndex}
              className="text-center"
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.productName'
              )}
              body={(_, { rowIndex }) => formatName(rowIndex, 'left')}
              style={{ minWidth: '6rem' }}
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.evaluativeCriteria'
              )}
              body={(_, { rowIndex }) => formatEvaluativeCriteria(rowIndex, 'left')}
              style={{ minWidth: '6rem' }}
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.note'
              )}
              body={(_, { rowIndex }) => formatNote(rowIndex, 'left')}
              style={{ minWidth: '6rem' }}
            />
          </DataTable>
        </div>
      </td>
      <td>
        <div className="my-2">
          <DataTable
            value={products2}
            showGridlines
            dataKey="id"
            responsiveLayout="scroll"
            scrollable
          >
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.order'
              )}
              body={formatIndex}
              className="text-center"
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.productName'
              )}
              body={(_, { rowIndex }) => formatName(rowIndex, 'right')}
              style={{ minWidth: '6rem' }}
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.evaluativeCriteria'
              )}
              body={(_, { rowIndex }) => formatEvaluativeCriteria(rowIndex, 'right')}
              style={{ minWidth: '6rem' }}
            />
            <Column
              header={t(
                'projectProposal.researchResult.productAndResearchResultDes.softProduct.fields.note'
              )}
              body={(_, { rowIndex }) => formatNote(rowIndex, 'right')}
              style={{ minWidth: '6rem' }}
            />
          </DataTable>
        </div>
      </td>
      <DiffColumn
        isDifferent={Object.values(diffObj ?? {})?.some(
          (item) =>
            item === true ||
            item?.evaluativeCriteria === true ||
            item?.name === true ||
            item?.note === true
        )}
      />
    </tr>
  );
}

SoftProductCompareTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products1: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  products2: PropTypes.array.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  diffObj: PropTypes.object.isRequired,
};
